import * as React from "react";
import { TextField, MenuItem } from "@mui/material";
import { round } from "mathjs";
import { Currency } from "../../interfaces/StockInterfaces";

const InrToNprRate = 1.6;

export const currencyStartAdornment = (currency: Currency, onChange: (e) => void): JSX.Element => (
  <TextField
    style={{ width: "150px", marginRight: "10px" }}
    select
    slotProps={{
      htmlInput: {
        style: { marginLeft: "5px" }
      },
      input: {
        disableUnderline: true
      }
    }}
    value={currency}
    onChange={(e) => onChange(e)}
  >
    {Object.values(Currency).map((val) => (
      <MenuItem value={val} key={val}>
        {val}
      </MenuItem>
    ))}
  </TextField>
);

export const convertToINR = (value: number): number => round(Number(value) / InrToNprRate, 2);

export const convertToRs = (value: number): number => round(Number(value) * InrToNprRate, 2);

export const processPrice = (currency: Currency, price: number): number => {
  if (currency === Currency.Inr) {
    return round(price * InrToNprRate, 2);
  }
  return price;
};
